import React from 'react';
import { Col, UncontrolledTooltip } from 'reactstrap';
import i18n from "../../../i18next";
import MaterialIcon from 'material-icons-react';


import BigSpenderSVG from '../../common/svgs/BigSpenderSVG';
import AtRiskSVG from '../../common/svgs/AtRiskSVG';
import LostSVG from '../../common/svgs/LostSVG';
import AverageFrequencySVG from '../../common/svgs/AverageFrequencySVG';
import AverageSVG from '../../common/svgs/AverageSVG';
import LifetimeSVG from '../../common/svgs/LifetimeSVG';
import ShoppingCartSVG from '../../common/svgs/ShoppingCartSVG';
import ModerateSVG from '../../common/svgs/ModerateSVG';
import VipSVG from '../../common/svgs/VipSVG';
import InfoSVG from '../../common/svgs/InfoSVG';
import WalletSVG from '../../common/svgs/WalletSVG';

const GeneralValueItem = props => {

    const { ColContainerStyle, item, itemHeader, itemValue, itemValueLabel, itemVip, ColContainerStyleRestaurantInsight, infoIconStyle } = styles;

    return (
        <Col sm={props.colSize} style={props.type==="restaurantInsight" ? ColContainerStyleRestaurantInsight : ColContainerStyle}>
            <div style={item}>
                <div>
                    {
                        //handle header for order frequency Item
                        props.header ?
                            <div style={itemHeader}>
                                {props.header}
                            </div> : null
                    }
                    {
                        //handle VIP STATUS
                        props.vip ?
                            <div style={itemVip}>
                                <VipSVG width={props.iconSize / 3} height={props.iconSize / 3} />
                            </div> : null
                    }
                    {renderSvg(props)}
                    <div style={{ ...itemValue, fontSize: props.valueFontSize }}>
                        {localizeValue(props.value)}
                    </div>
                    {
                        props.label ?
                            <div style={props.type ==="restaurantInsight" ? {...itemValueLabel, fontSize: '17px'} : {...itemValueLabel, fontSize: '18px'}}>
                                {props.label}
                            </div> : null
                    }
                </div>
                {/* {
                    props.type === "restaurantInsight" ?
                    <div style={infoIconStyle} id={'infoSvg' + props.icon}>
                        <InfoSVG fill={'#0288d1'}/>
                    </div> : null
                } */}
            </div>
           {/* {props.type === "restaurantInsight" ? <UncontrolledTooltip placement="top" target={'infoSvg' + props.icon} >
                {renderTooltip(props.icon)}
            </UncontrolledTooltip> : null} */}
        </Col>
    );
}

export default GeneralValueItem;

const renderSvg = props => {
    if (props.icon) {
        switch (props.icon) {
            case "average_frequency": return <AverageFrequencySVG width={props.iconSize} height={props.iconSize} />
            case "average": return <AverageSVG width={props.iconSize} height={props.iconSize} />
            case "lifetime": return <LifetimeSVG width={props.iconSize} height={props.iconSize} />
            case "shopping_cart": 
            case "shopping_cart_orders_last_year": return <ShoppingCartSVG width={props.iconSize} height={props.iconSize} />
            case "people": return <MaterialIcon icon="people" color="#000" size={props.iconSize} />
            case "wallet": return <WalletSVG  fill={'black'} width={props.iconSize} height={props.iconSize} />
        }
    } else {
        switch (props.value) {
            case 'BIG_SPENDER': return <BigSpenderSVG width={props.iconSize} height={props.iconSize} />
            case 'REGULAR': return <ModerateSVG width={props.iconSize} height={props.iconSize} />
            case 'INFREQUENT': return <ModerateSVG width={props.iconSize} height={props.iconSize} />
            case 'AT_RISK': return <AtRiskSVG width={props.iconSize} height={props.iconSize} />
            case 'LOST': return <LostSVG width={props.iconSize} height={props.iconSize} />
            case 'VIP': return <VipSVG width={props.iconSize} height={props.iconSize} />
        }
    }
}

const localizeValue = value => {
    switch (value) {
        case 'BIG_SPENDER': return i18n.t('screens:customerInsightScreen.bigSpender');
        case 'REGULAR': return i18n.t('screens:customerInsightScreen.regular');
        case 'INFREQUENT': return i18n.t('screens:customerInsightScreen.infrequent');
        case 'AT_RISK': return i18n.t('screens:customerInsightScreen.atRisk');
        case 'LOST': return i18n.t('screens:customerInsightScreen.lost');
        default: return value;
    }
}

const renderTooltip = icon => {
    switch(icon) {
        case 'shopping_cart': return i18n.t('screens:restaurantInsightScreen.ordersCountTooltip');
        case 'wallet': return i18n.t('screens:restaurantInsightScreen.totalSpentToolip');
        case 'average': return i18n.t('screens:restaurantInsightScreen.averageOrdersTooltip');
        case 'people': return i18n.t('screens:restaurantInsightScreen.uniqueCustomersTooltip');
        case 'shopping_cart_orders_last_year': return i18n.t('screens:restaurantInsightScreen.ordersLastYearTooltip');
        case 'lifetime': return i18n.t('screens:restaurantInsightScreen.orderFrequencyPerDayTooltip');
    }
}

const styles = {
    ColContainerStyle: {
        padding: '10px'
    },
    ColContainerStyleRestaurantInsight: {
        border: 'solid 3px rgb(235, 240, 244)',
        margin: '15px 7px 0px 7px'
    },
    item: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '170px',
        backgroundColor: 'white',
        textAlign: 'center'
    },
    itemHeader: {
        fontSize: '14px',
        // color: 'rgb(130,131,138)',
        color: 'black',
        fontWeight: 'bold',
        padding: '5px 10px 0 10px'
    },
    itemValue: {
        color: 'rgb(17,144,216)',
    },
    itemValueLabel: {
        // fontSize: '18px',
        // color: 'rgb(130,131,138)',
        color: 'black',
        fontWeight: 'bold'
    },
    itemVip: {
        textAlign: 'right',
        marginRight: '-5px'
    },
    infoIconStyle: {
        position: 'absolute',
        right: '0.5rem',
        top: '0.3rem'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/GeneralValueItem.js